import i18n from "../i18n";

import { clearToken, getToken } from "@/lib/authStorage";

import axios from "axios";

const api = axios.create({ baseURL: import.meta.env.VITE_BACKEND });

api.interceptors.request.use((config) => {
  const token = getToken();
  const language = i18n.language;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers["x-language"] = language || "tr";
  config.headers["x-from"] = "panel";

  return config;
});

// Blacklist'e alınmış / süresi dolmuş token ile gelen isteklerde backend 401 döner;
// token'ı temizleyip kullanıcıyı login'e yönlendir.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default api;
